import { Component, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { DialogConfig } from '../../../base/components/dialog/dialog-config';
import { ReportDataTableComponent } from '../report-data-table/report-data-table.component';
import _moment from 'proxies/dayjs';
import { ModalSize } from 'src/modules/base/services/smart-modal.service';
import { PaymentStatusComponent } from '../payment-status/payment-status.component';

@Component({
    selector: 'app-popup-confirm',
    templateUrl: '../report-data-table/report-data-table.component.html',
    styleUrls: ['../report-data-table/report-data-table.component.scss'],
    standalone: false
})
export class PopupConfirmComponent extends ReportDataTableComponent {
  payer_details: any;
  _Arr: any = [];
  _price: any = 0;
  count: any;
  moment = _moment;

  constructor(
    public injector: Injector,
    public smartModal: BsModalService,
    public router: Router,
    public route: ActivatedRoute,
    public dialogConfig: DialogConfig
  ) {
    super(injector, router, route, smartModal)
  }

  confirmBoxResource(data, action) {
    if (action && action.validate_datasource) {
      this.validateConfirmResource(data, action, (result: any, item) => {
        if (result) {
          if (action.msg_key && action.msg_type && action.msg_type == "composite") {
            action['message'] = (eval)(action.msg_key)(item) + " " + action.message
          }
          super.confirmBoxResource(data, action)
        }
      })
    }
    else if (action && action.RescheulePackage) {
      this.EmergencyReschedule(data, action, res => {
        if (res && res != undefined)
          this.bindGridFn();
      })
    } else {
      super.confirmBoxResource(data, action)
    }
  }

  confirmResource(item, action) {
    this.baseService.action(item, action.datasource.action, action.datasource.application, action.datasource.resource).subscribe(
      (data: any) => {
        this.communicationService.emitChange({ completed: true });
        if (data.errCode == -1) {
          this.alerts.error(data.message);
          if (action.refresh != undefined && action.refresh)
            this.bindGridFn();
        } else {
          if (action && action.validate_datasource) {
            this.consumeSameservice(item)
          }else{
            this.bindGridFn();
          }
          if (this._currentData.currentAction == 'ADD') {
            this.alerts.success("Added Successfully");
          } else {
            this.alerts.success("Updated Successfully");
          }
          if (action.hasOwnProperty('redirectLink')) {
            let url = ''
            if (this.router.url.includes('?')) {
              this.postUrl(this.router.url.split('?')[0], action, item);
            } else {
              this.postUrl(this.router.url, action, item);
            }
          }
          if (action.show_message) {
            this.alerts.successWithMessage("", this.baseService.buildDyanamicStr(action.show_message, { data: data.resource[0] }))
          }
        }
        this.loader.hideSpinner();
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
      });
  }

  consumeSameservice(data) {
    this.baseService.get("GET_PACKAGE_ITEMS", "package_serviceRequestId:" + data.serviceRequestId, "package_items_details", "order").subscribe((res: any) => {
      if (res.errCode == 0) {
        if (res.resource.filter((x) => x.consume_while_checkin == true).length != 0) {
          this.count = res.resource.filter((x) => x.consume_while_checkin == true).length;
          res.resource.filter((x) => x.consume_while_checkin == true).forEach((elem) => {
            this.getMachineFee(elem, data)
          })
        }else{
          this.bindGridFn()
        }
      } else {
        this.alerts.error(res.message)
      }
    })
  }

  getMachineFee(detail, patieneDetail) {
    this.loader.showSpinner()
    var data = {
      args: "priorityCode:" + detail.priorityCode + ",serviceId:" + detail.serviceItemId + ",payer_id:" + patieneDetail.payer_id + ",serviceType:" + detail.serviceType_code + ",quantity:1,patient_id:" + patieneDetail.patient_id + ",billing_category_id:" + patieneDetail.billing_category_id + ",appointment_mode:OP,patient_type:OP"
    }
    if (this.appService.getUniversalConfig('multi_care_type')) {
      data.args += ",care_type:" + patieneDetail.care_type
    }
    this.baseService.getData(data, '', "tariff_service_item", "facility-management", "GET_SERVICE_ITEM_PRICE").subscribe(
      res => {
        this.loader.hideSpinner()
        if (res.errCode == 0) {
          if (res.resource.length == 0) {
            this.alerts.error("Fee is not created for " + detail.serviceItemName)
          } else {
            this.payer_details = {
              "payer_id": patieneDetail.payer_id,
              "payer_name": patieneDetail.payer_name,
              "payer_type": patieneDetail.payer_type
            }
            this._price += res.resource[0].price
            let obj1 = {
              "serviceItemId": detail.serviceItemId,
              "order_date_time": this.moment().valueOf(),
              "serviceType": detail.serviceType,
              "serviceType_code": detail.serviceType_code,
              "department_id": detail.department_id,
              "department_name": detail.department_name,
              "subDepartment_id": detail.subDepartment_id,
              "subDepartment_name": detail.subDepartment_name,
              "slotId": "",
              "package_name": detail.package_name,
              "serviceDate": this.moment().startOf('day').valueOf(),
              "serviceStartTime": 0,
              "total_amount": res.resource[0].price,
              "serviceEndTime": 0,
              "is_home_care": false,
              "allow_multiple_consumption": false,
              "price": res.resource[0].price,
              "serviceItemCode": detail.serviceItemCode, ///e.g. code
              "serviceItemName": detail.serviceItemName,
              "service_mrp": res.resource[0].price,
              "service_selling_amount": res.resource[0].price,
              "priority": detail.priority,
              "priorityCode": detail.priorityCode,
              "part_of_package": true,
              "package_serviceRequestId": detail.package_serviceRequestId,
              "package_id": detail.package_id,
              "is_walkin": true,
              "qty": 1,
              "extra_data": {
                "facility_name": this.appService.getOrganization().org_name,
              }
            }
            var Arr = []; let Object = {}
            if (detail.serviceType_code == 'radiology') {
              Object['participantId'] = "";
              Object['participantName'] = "";
              Object['participantRole'] = "MACHINE";
              Object['action'] = "MACHINE";
              Arr.push(Object)
            } else {
              Object['participantId'] = ""
              Object['participantName'] = ""
              Object['participantRole'] = "";
              Arr.push(Object)
            }
            obj1['participant'] = Arr;
            // return obj;
            this._Arr.push(obj1);

            let obj = {
              "patient_details": {
                "patient_id": patieneDetail.patient_id,
                "patientType": patieneDetail.patientType,
                "uhId": patieneDetail.uhId,
                "addmissionId": "",
                "referred_by_name": patieneDetail.referred_by_name,
                "referred_by_id": patieneDetail.referred_by_id,
                "payer_info": this.payer_details
              },
              "payment_status": "pending",
              "payment_details": [
                {
                  "payment_mode": "PAV"
                }
              ],
              "services": this._Arr,
              "facility_id": detail.facility_id,
              "remarks": "",
              "is_walkin": true,
              "total_amount": this._price,
              "net_amount": this._price,
              "service_mrp": this._price,
              "service_selling_amount": this._price,
              "orderedFrom": "OP Package Consume",
              "old_serviceRequestId": detail.package_serviceRequestId,
              "order_device": !this.utilService.isMobile() ? "WEB" : (this.utilService.isAndroid() ? "ANDROID" : "IOS"),
              "order_type": "Package"
            }
            if (patieneDetail && patieneDetail.tag_data != undefined && patieneDetail.tag_data != "") {
              obj['tag_data'] = patieneDetail.tag_data;
            }
            if (this._Arr.length == this.count) {
              this.consumePackage(obj);
            }
          }
        } else {
          this.alerts.error(res.message)
        }
      })
  }

  consumePackage(resource) {
    this.loader.showSpinner()
    // let customAction = this.orderFromReapply ? "Bypass_service_item" : "OP_ORDER"
    this.baseService.action(resource, "OP_ORDER", "order", "service_request_handler").subscribe(
      response => {
        this.loader.hideSpinner()
        this._Arr = [];
        this.bindGridFn();
        this._price = 0;
        if (response.errCode == 0) {
          this.alerts.success("Request Successful");
        } else {
          this.alerts.error(response.message)
        }
      })
  }

  validateConfirmResource(menudata, action, cb) {
    if (action.validate_datasource != undefined && action.validate_expression != undefined) {
      var apiObj: any = {};
      var datasource = JSON.parse(JSON.stringify(action.validate_datasource));
      apiObj.resource = datasource.resource != undefined ? datasource.resource : this._currentData.resource;
      apiObj.query_id = datasource.query_id != undefined ? datasource.query_id : 'GET_BY_ID';
      apiObj.application = datasource.application != undefined ? datasource.application : this.appService.getApplication();
      apiObj.args = datasource.args != undefined ? this.baseService.buildDyanamicStr(datasource.args, { data: menudata }) : '';
      apiObj.filter = datasource.filter != undefined ? this.baseService.buildDyanamicStr(datasource.filter, { data: menudata }) : '';
      this.loader.showSpinner();
      this.baseService.getByDataSource(apiObj).subscribe(
        (data: any) => {
          let item
          if (data.errCode == -1) {
            this.alerts.error(data.message);
            cb(false, {})
            this.loader.hideSpinner();
          } else {
            item = data.resource[0];
            this.loader.hideSpinner();
            let valid = eval(action.validate_expression)
            if (!valid) {
              if (action.msg_key && action.msg_type && action.msg_type == "composite") {
                if (action.bypass_error) {
                  cb(true, item)
                  // this.byPassMessage((eval)(action.msg_key)(item), (res: any) => {
                  //   valid = res
                  //   cb(res)
                  // })
                } else {
                  this.alerts.error((eval)(action.msg_key)(item))
                }
              } else {
                if (action.bypass_error) {
                  cb(true, item)
                } else {
                  this.alerts.error(action.err_message)
                }
              }
            }
            valid ? cb(true, item) : cb(false,item)
          }
        }, error => {
          console.log(error);
          this.alerts.error('API error');
          this.loader.hideSpinner();
          cb(false);
        }
      )
    } else {
      console.error("please define datasource");
    }

  }

  byPassMessage(message, callback) {
    const dialogRef = this.modalService.confirm('Check-In Package', message + " do you still want to check-in? ", ModalSize.Sm);
    dialogRef.subscribe(result => {
      if (result) {
        callback(true)
      } else {
        callback(false)
      }
    },
      () => { });
  }

  EmergencyReschedule(data, menuObj, callback) {
    if (menuObj.RescheulePackage == 'EmergencyBookingPhc') {
      let msg = "Are you sure you want to reschedule for current date time?"
      const dialogRef = this.modalService.confirm("Emergency Reschedule", msg)
      dialogRef.subscribe(result => {
        if (result) {
          let result: any = {};
          result['is_emergency'] = true
          result['serviceRequestId'] = data.serviceRequestId;
          result['over_booking_status'] = data.over_booking_status;
          result['serviceDate'] = new Date().setHours(0, 0, 0, 0)
          result['slotId'] = data.slotId;
          result['slotNo'] = data.slotNo;
          result['id'] = data.id;
          result['slotStartTime'] = data.slotStartTime;
          result['slotEndTime'] = data.slotEndTime;
          this.baseService.action(result, menuObj.datasource.action, menuObj.datasource.application, menuObj.datasource.resource).subscribe(data => {
            if (data.errCode == -1) {
              this.alerts.error(data.message);
              callback(false);
            } else {
              this.alerts.success(data.message);
              callback(true);
            }
          })
        }
      })
    }
  }

  ngAfterViewInit() {
    // super.ngAfterViewInit();
    this.route.queryParams.subscribe((res: any) => {
      if (res.hasOwnProperty('orderId'))
        this.showPaymentPopUp(res);
    })
  }

  showPaymentPopUp(data: any) {
      const config: ModalOptions = {
        backdrop: 'static',
        keyboard: false,
        animated: true,
        ignoreBackdropClick: true,
        initialState: {
          data: data
        }
      };
      this.modal.show(PaymentStatusComponent, config);
    }

}